// extracted by mini-css-extract-plugin
export default {"modal":"JxzDKG_WPcsxSygWQJOJ","content":"bcIc1OQKx8DQVcuREb49"};